import { create } from 'zustand'

import { StreamedReference } from 'api/conversations/types'
import { MessageReference } from 'types/Api'

type ReferencesByMessageId = Record<string, MessageReference[]>

type ReferencesState = {
  addReference: (reference: StreamedReference) => void
  streamingReferences: ReferencesByMessageId
  resetStreamingReferences: VoidFunction
}

const initialState: Pick<ReferencesState, 'streamingReferences'> = {
  streamingReferences: {},
}

const emptyArray: MessageReference[] = []

const useStreamingReferencesStore = create<ReferencesState>(set => ({
  ...initialState,
  addReference: ({ reference, messageId }) => {
    set(({ streamingReferences }) => {
      const messageReferences = streamingReferences[messageId] ?? []

      const isExistingReference = messageReferences.some(messageReference => messageReference.refId === reference.refId)

      const updatedMessageReferences
        = isExistingReference
          ? messageReferences.map(messageReference =>
              messageReference.refId === reference.refId ? reference : messageReference,
            )
          : [...messageReferences, reference]

      return {
        streamingReferences: {
          ...streamingReferences,
          [messageId]: updatedMessageReferences,
        },
      }
    })
  },
  resetStreamingReferences: () => set(initialState),
}))

export const useAddStreamingReference = () =>
  useStreamingReferencesStore(state => state.addReference)

export const useStreamingReferences = (messageId?: string) =>
  useStreamingReferencesStore((state) => {
    if (!messageId) return emptyArray
    return state.streamingReferences[messageId] ?? emptyArray
  })

export const useResetStreamingReferences = () =>
  useStreamingReferencesStore(state => state.resetStreamingReferences)
